import React from 'react';
import { Facebook, Instagram, Twitter } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-primary-black text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* General Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4 text-primary-gold font-display">The Creamery</h3>
            <div className="space-y-2 text-gray-300">
              <p>Bainsford Main Street</p>
              <p>Falkirk</p>
              <p>FK2 7NU</p>
              <h4>Contact</h4>
              <p>Telephone: 01324 636330</p>
              <p>enquiries@thecreamerysportsbar.co.uk</p>
              <div className="flex space-x-4 py-8">
                <a 
                  href="https://www.facebook.com/thecreameryfalkirk" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-primary-gold transition-colors"
                  aria-label="Visit our Facebook page"
                >
                  <Facebook className="w-5 h-5" aria-hidden="true" />
                </a>
                <a 
                  href="https://www.instagram.com/thecreameryfalkirk" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-primary-gold transition-colors"
                  aria-label="Visit our Instagram page"
                >
                  <Instagram className="w-5 h-5" aria-hidden="true" />
                </a>
                <a 
                  href="https://twitter.com/thecreameryfalkirk" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-gray-400 hover:text-primary-gold transition-colors"
                  aria-label="Visit our Twitter page"
                >
                  <Twitter className="w-5 h-5" aria-hidden="true" />
                </a>   </div>
            </div>
          </div>
          
          {/* Restaurant Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4 text-primary-gold font-display">Restaurant</h3>
            <div className="space-y-2 text-gray-300">
              <p>Opening Hours:</p>
              <p>Sun-Fri: 12pm - 7pm</p>
              <p>Sat: 12pm - 7:30pm</p>
            </div>
          </div>

          {/* Snooker Hall Info */}
          <div>
            <h3 className="text-2xl font-bold mb-4 text-primary-gold font-display">Snooker & Pool</h3>
            <div className="space-y-2 text-gray-300">
              <p>Opening Hours:</p>
              <p>Mon-Sun: 11am - 11pm</p>
              <p className="mt-4">Table Rates:</p>
              <p>Pool: £11/hour</p>
              <p>Snooker: £11/hour</p>
            </div>
          </div>

          
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2026 The Creamery. All rights reserved.</p>
          <div className="mt-2 space-x-4">
            <a href="/news" className="hover:text-primary-gold transition-colors">News</a>
            <a href="/privacy" className="hover:text-primary-gold transition-colors">Privacy Policy</a>
            <a href="/terms" className="hover:text-primary-gold transition-colors">Terms of Service</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
